import { defineMessages } from 'react-intl';

export default defineMessages({
    message: {
        id: '_.automatedLendingDecision.decisionError.companyDetailsIncorrect.message',
        defaultMessage:
            "We couldn't make a decision because we couldn't match your information to Companies House. Please check if your company details are correct and try again."
    }
});
